<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import Controlbar from "./components/commons/Controlbar.vue";
import Navbar from "./components/commons/Navbar.vue";
import preloaderImage from "../static/assets/images/safari-pinned-tab.svg";

export default {
  name: "app",
  data() {
    return {
      preloaderImage,
      id: this.$route.params.id ? this.$route.params.id : null,
      type: "workouts",
    };
  },
  components: {
    Navbar,
    Controlbar,
  },
  computed: {
    ...mapGetters({
      preloader: "commons/preloader",
    }),
    currentRoute() {
      if (this.$route) return this.$route.path ? this.$route : null;
    },
    fullScreenMode() {
      const fullScreen = ["auto-cue", "printscript", "login"];
      return (
        fullScreen.filter((fullScreenPath) =>
          this.currentRoute.path.includes(fullScreenPath)
        ).length > 0
      );
    },
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow"
        ) {
          return "stretchflows";
        }
      }
      return "workouts";
    },
  },
  methods: {
    updateActivity() {
      this.currentActivity.status = "ready-to-film";
      this.$store.dispatch(
        `${this.currentType}/updateActivity`,
        this.$route.params.id
      );
    },
  },
  watch: {
    currentRoute() {
      this.$store.commit("scripts/setOpened", false);
    },
  },
};
</script>

<style lang="scss">
.fixed-spacing {
  height: 70px;

  &.title-active {
    height: 150px;
  }
}
.preloader {
  position: fixed;
  z-index: 99999;
  background: #00000069;
  width: 100%;
  height: 100%;
  img {
    width: 70px;
    animation: rotation 2s infinite linear;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>

<template>
  <div id="app">
    <div
      class="preloader justify-content-center align-items-center d-flex"
      v-if="preloader"
    >
      <img :src="preloaderImage" />
    </div>

    <navbar v-if="!fullScreenMode"></navbar>
    <controlbar v-if="!fullScreenMode"></controlbar>
    <div
      class="fixed-spacing"
      v-if="!fullScreenMode"
      :class="
        currentRoute.path != '/' &&
        currentRoute.path != '/todo' &&
        currentRoute.path != '/recipes' &&
        currentRoute.path != '/learn/create' &&
        currentRoute.path != '/analytics'
          ? 'title-active'
          : ''
      "
    ></div>
    <router-view v-if="fullScreenMode"></router-view>
    <div
      class="container-fluid"
      :class="fullScreenMode ? '' : 'py-4 px-5 p-32'"
      v-else
    >
      <router-view></router-view>
    </div>
  </div>
</template>
